<template>
  <app-content class="h-panel" style="overflow: hidden">
    <div class="h-panel-body voucher-list">
      <table class="header">
        <tr>
          <th style="width: 50px"><input :checked="checkAll" type="checkbox" @click="checkAll=!checkAll"></th>
          <td style="width: 215px">摘要</td>
          <td>科目</td>
          <td align="right" style="width: 130px">借方金额</td>
          <td align="right" style="width: 130px">贷方金额</td>
        </tr>
      </table>
      <table v-if="!datas.length">
        <tr>
          <td colspan="5" class="text-center padding">暂无数据</td>
        </tr>
      </table>
      <table class="details" v-for="data in datas" :key="data.id">
        <tr class="details-header">
          <th style="width: 50px"><input :class="{'display':data._checked}" v-model="data._checked" type="checkbox"></th>
          <td colspan="2">日期：{{ data.voucherDate }} 凭证字号：{{ data.word }}-{{ data.code }}
            <template v-if="data.receiptNum > 0">
              <DropdownCustom :toggle-icon="false" class-name="h-text-dropdown">
                <span class="ml-8px text-hover primary-color">
                <i class="fa fa-paperclip"></i> {{ data.receiptNum }}
                </span>
                <template #content>
                  <div class="w-400px">
                    <div class="h-150px">
                      <vxe-table ref="billListTable" :data="data.billList" :show-header="false" height="auto">
                        <vxe-column field="name">
                          <template #default="{row}">
                            <a :href="'/api'+row.url+'?name='+row.name" target="_blank">{{ row.name }}</a>
                          </template>
                        </vxe-column>
                      </vxe-table>
                    </div>
                  </div>
                </template>
              </DropdownCustom>
            </template>
          </td>
          <td colspan="2">
            <div class="actions flex justify-end items-center">
              <a :href="`/api/pdf/voucher?id=${data.id}`" target="_blank" class="fa fa-print">打印</a>
              <router-link @success="loadList" width="1024px" v-if="User.role!=='View' && (!currentAccountSets.voucherReviewed || !data.auditMemberId)" class="span fa fa-edit" :to="{name:'VoucherForm',params:{voucherId:data.id}}">修改</router-link>
              <span v-if="User.role!=='View' && (!currentAccountSets.voucherReviewed || !data.auditMemberId)" @click="remove(data)" class="fa fa-trash">删除</span>
              <router-link @success="loadList" width="1024px" v-if="User.role!=='View'" class="span fa fa-copy" :to="{name:'VoucherForm',params:{voucherId:data.id,copy:true}}">复制</router-link>
              <router-link class="text-hover" width="80vw" v-if="currentAccountSets.voucherReviewed && data.auditMemberId" tag="span" :to="{name:'VoucherForm',params:{voucherId:data.id}}">
                <i class="h-icon-completed green-color" content="已审核"></i> 查看
              </router-link>
            </div>
          </td>
        </tr>
        <tr v-for="d in data.details" :key="d.id">
          <th></th>
          <td style="width: 215px">
            {{ d.summary }} <span v-if="d.currencyName && d.currencyId !== localCurrency.id">({{ d.currencyName }}：{{ d.originalAmount }}，汇率：{{ d.exchangeRate }})</span>
            <template v-if="d.subject&&d.num&&d.price">
              (数量:{{ d.num }}<span class="dark4-color">{{ d.subject.unit }}</span>，单价:{{ d.price }}<span class="dark4-color">元</span>)
            </template>
          </td>
          <td>{{ d.subjectName }}<span v-if="d.auxiliaryDetailId">_{{ d.auxiliaryTitle }}</span></td>
          <td align="right" style="width: 130px">{{ numFormat(d.debitAmount) }}</td>
          <td align="right" style="width: 130px">{{ numFormat(d.creditAmount) }}</td>
        </tr>
        <tr class="font-bold">
          <td></td>
          <td>合计</td>
          <td>{{ dxMoney(data.debitAmount) }}</td>
          <td align="right">{{ numFormat(data.debitAmount) }}</td>
          <td align="right">{{ numFormat(data.creditAmount) }}</td>
        </tr>
      </table>
      <Pagination v-model="pagination" @change="currentChange" layout="pager" small align="center"/>
    </div>
  </app-content>
</template>

<script>
import Qs from "qs";
import {mapActions, mapGetters, mapState} from 'vuex'
import {h} from 'vue'
import {clone, pick} from "xe-utils";
import {layer} from "@layui/layer-vue";
import VoucherImport from "@/views/voucher/VoucherImport";
import manba from "manba";
import voucher from "@/api/voucher";
import {downloadBlob} from "download.js";
import FinishingOffNo from "@/views/voucher/FinishingOffNo.vue";
import {message} from "heyui.ext";

export default {
  name: "CheckoutVoucher",
  props: {
    voucherIdList: {
      type: Array,
      default: () => []
    },
    checkoutTplId: String
  },
  data() {
    return {
      datas: [],
      accountDate: null,
      pagination: {
        page: 1,
        pageSize: 20,
        total: 0
      },
      params: {
        voucherDate: {start: null, end: null},
        audit: 0,
        id: []
      },
      loading: false,
      checkAll: false,
      param: [{title: '打印全部', key: 'printAll'}, {title: '打印选中', key: 'printCheck'}]
    };
  },
  watch: {
    checkAll(nval) {
      let data = Array.from(this.datas);
      data.forEach(val => val._checked = nval);
      this.datas = data;
    }
  },
  computed: {
    ...mapState(['User', 'currentAccountSets']),
    ...mapGetters(['checkoutSelect', 'localCurrency']),
    date() {
      return manba(this.accountDate);
    }
  },
  methods: {
    ...mapActions(['init']),
    currentChange() {
      this.loadList();
    },


    printAll() {
      let param = Qs.stringify({audit: this.params.audit, voucherDateStart: this.params.voucherDate.start, voucherDateEnd: this.params.voucherDate.end}, {indices: false});
      window.open(`/api/pdf/voucher?${param}`);
    },
    printCheck() {
      let checked = this.datas.filter(value => value._checked);
      if (checked.length) {
        let param = Qs.stringify({id: checked.map(value => value.id)}, {indices: false});
        window.open(`/api/pdf/voucher?${param}`);
      } else {
        this.$Message("未选择记录");
      }
    },
    loadList() {
      const loadId = layer.load(2);
      voucher.list(this.pagination, this.params).then(({data}) => {
        this.datas = data.results || [];
        this.pagination = {
          page: data.page,
          size: data.size,
          total: data.total
        }
      }).finally(() => layer.close(loadId))
    },
    remove(row) {
      this.$Confirm("确认删除?").then(() => {
        const loadId = layer.load(2);
        voucher.delete([pick(row, ['id', 'year', 'month'])]).then(({data}) => {
          if (data && data.length) {
            this.$Message("部分删除不成功，请检查所在账期是否已结账~")
          } else {
            this.$Message("删除成功~")
            this.init();
          }

          this.loadList();
        }).finally(() => layer.close(loadId))
      });
    },


    audit() {
      let checked = this.datas.filter(value => value._checked);
      if (checked.length) {
        const vdates = new Set(checked.map(val => val.year + "" + val.month))
        if (vdates.size > 1) {
          this.$Message("不能跨期操作~");
          return
        }
        this.$Confirm("亲，确认要审核吗?").then(() => {
          this.loading = true;
          this.$api.voucher.audit({
            checked: checked.map(value => value.id),
            year: checked[0].year,
            month: checked[0].month
          }).then(() => {
            this.loadList();
            this.$Message("审核成功！");
          }).finally(() => {
            this.loading = false;
          });
        });
      } else {
        this.$Message("未选择记录");
      }
    },
    cancelAudit() {
      let checked = this.datas.filter(value => value._checked);
      if (checked.length) {
        const vdates = new Set(checked.map(val => val.year + "" + val.month))
        if (vdates.size > 1) {
          this.$Message("不能跨期操作~");
          return
        }
        this.$Confirm("亲，确认要取消审核吗?").then(() => {
          this.loading = true;
          this.$api.voucher.cancelAudit({
            checked: checked.map(value => value.id),
            year: checked[0].year,
            month: checked[0].month
          }).then(() => {
            this.loadList();
            this.$Message("取消审核成功！");
          }).finally(() => {
            this.loading = false;
          });
        });
      } else {
        this.$Message("未选择记录");
      }
    },
  },
  created() {
    this.params.voucherDate.start = manba(this.currentAccountSets.currentAccountDate).format("YYYY-M");
    this.params.voucherDate.end = this.params.voucherDate.start;
    this.params.id = this.voucherIdList;//凭证列表
    this.cloneParams = clone(this.params, true);

    this.loadList();

  }
};
</script>
